import React, { useState } from "react";
import { BASE_URL } from "../../config";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/auth`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: username,
          password: password,
          method: "credentials",
          database: "odoo18_clinic",
        }),
      });

      const data = await response.json();
      if (!response.ok || !data?.token) {
        setError(data?.message || "Sai tài khoản hoặc mật khẩu!");
        setLoading(false);
        return;
      }
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("token", data.token);
      localStorage.setItem("username", data.name || "");
      const operatingUnits = data.operating_unit_ids || [];
      localStorage.setItem("company", JSON.stringify(operatingUnits));

      try {
        const roles = data.roles || data.role_ids || [];
        const codes = new Set();
        roles.forEach((role) => {
          const nodes = role?.node_ids || [];
          nodes.forEach((n) => {
            if (n?.code) codes.add(n.code);
          });
        });
        localStorage.setItem("permissions_codes", JSON.stringify(Array.from(codes)));
      } catch (e) {
        localStorage.setItem("permissions_codes", JSON.stringify([]));
      }

      if (operatingUnits.length > 0) {
        localStorage.setItem("selected_operating_unit_id", operatingUnits[0].id);
        localStorage.setItem("selected_operating_unit", JSON.stringify(operatingUnits[0]));
        localStorage.setItem("selected_company_name", operatingUnits[0].name);
      }

      setLoading(false);
      onLogin();
    } catch (err) {
      console.error("Error during API call:", err);
      setError("Không thể kết nối đến máy chủ. Vui lòng thử lại!");
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f3fbfd" }}>
      <div
        style={{
          padding: 24,
          width: 380,
          minHeight: 350,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          background: "#fff",
          borderRadius: 8,
          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        }}
      >
        <h2 style={{ margin: 0, marginBottom: 30, color: "#00897b", textAlign: "center", fontSize: 24 }}>Đăng nhập hệ thống</h2>
        <form onSubmit={handleSubmit}>
          <label style={{ display: "block", marginBottom: 8, fontSize: 14 }}>Tài khoản</label>
          <input
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="login-input"
            style={{ width: "100%", fontSize: 14, marginBottom: 20, boxSizing: "border-box" }}
            aria-label="Tài khoản"
          />

          <label style={{ display: "block", marginBottom: 8, fontSize: 14 }}>Mật khẩu</label>
          <div style={{ position: "relative", marginBottom: 20 }}>
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              style={{ width: "100%", fontSize: 14, padding: "10px 40px 10px 12px", boxSizing: "border-box" }}
              aria-label="Mật khẩu"
            />
            <button
              type="button"
              onClick={() => setShowPassword((s) => !s)}
              aria-label={showPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
              title={showPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
              style={{
                position: "absolute",
                right: 8,
                top: "50%",
                transform: "translateY(-50%)",
                border: "none",
                background: "transparent",
                padding: 6,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {showPassword ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 3L21 21" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M10.58 10.58A3 3 0 0013.42 13.42" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path
                    d="M17.94 17.94C16.02 19.17 13.67 20 12 20c-4 0-7-4-9-8 1.32-2.5 3.78-5 6.63-6.53"
                    stroke="#666"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2.47 12.88C3.93 15.82 7.08 19 12 19c4 0 7-4 9-8-1.32-2.5-3.78-5-6.63-6.53"
                    stroke="#666"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </button>
          </div>

          <div style={{ minHeight: 24, marginBottom: 8 }}>
            <div style={{ color: "#d32f2f", fontSize: 14, visibility: error ? "visible" : "hidden" }} aria-live="polite">
              {error || " "}
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "10px 12px",
              background: "#1976d2",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              cursor: loading ? "not-allowed" : "pointer",
              fontSize: 15,
            }}
          >
            {loading ? "Đang đăng nhập..." : "Đăng nhập"}
          </button>
        </form>
      </div>
    </div>
  );
}
